<ng-container
    *ngrxLet="{
        riskTableMax: riskTableMax$,
        populationDensityBoxes: populationDensityBoxes$,
        densityAfterMitigation: densityAfterMitigation$
    } as vm"
>
    <p class="risk-levels-label">{{ "dtmUi.riskLevels.populationDistributionLabel" | transloco }}</p>
    <table class="risk-levels-table">
        <thead>
            <tr>
                <th>{{ "dtmUi.riskLevels.riskColumnLabel" | transloco }}</th>
                <th>{{ "dtmUi.riskLevels.initialValueColumnLabel" | transloco }}</th>
                <th *ngIf="vm.riskTableMax">{{ "dtmUi.riskLevels.finalValueColumnLabel" | transloco }}</th>
            </tr>
        </thead>
        <tbody>
            <tr class="row-highest" [class.selected]="vm.densityAfterMitigation === RiskLevels.Highest">
                <td class="risk-title">
                    <div class="tooltip-container">
                        {{ "dtmUi.riskLevels.riskHighest.shortLabel" | transloco }}
                        <div class="tooltip">
                            <dtm-ui-popover>
                                <div [innerHTML]="'dtmUi.riskLevels.riskHighest.tooltipText' | transloco"></div>
                            </dtm-ui-popover>
                        </div>
                    </div>
                </td>
                <td>
                    ~{{ vm.populationDensityBoxes | invoke : getBoxShareRatioRiskLevels : RiskLevels.Highest | percent
                    }}<span>
                        {{
                            "dtmUi.riskLevels.gridValue"
                                | transloco : { value: vm.populationDensityBoxes | invoke : getRiskLevelGridValue : RiskLevels.Highest }
                        }}
                    </span>
                </td>
                <td *ngIf="vm.riskTableMax">
                    <div class="tooltip-container">
                        ~{{ vm.riskTableMax | invoke : getBoxShareRatioColorBox : ColorBox.Blue | percent }}
                        <span>
                            {{
                                "dtmUi.riskLevels.gridValue"
                                    | transloco : { value: vm.riskTableMax | invoke : getColorBoxGridValue : ColorBox.Blue }
                            }}
                        </span>
                    </div>
                </td>
            </tr>
            <tr class="row-high" [class.selected]="vm.densityAfterMitigation === RiskLevels.High">
                <td class="risk-title">
                    <div class="tooltip-container">
                        {{ "dtmUi.riskLevels.riskHigh.shortLabel" | transloco }}
                        <div class="tooltip">
                            <dtm-ui-popover>
                                <div class="tooltip-text" [innerHTML]="'dtmUi.riskLevels.riskHigh.tooltipText' | transloco"></div>
                            </dtm-ui-popover>
                        </div>
                    </div>
                </td>
                <td>
                    ~{{ vm.populationDensityBoxes | invoke : getBoxShareRatioRiskLevels : RiskLevels.High | percent
                    }}<span>
                        {{
                            "dtmUi.riskLevels.gridValue"
                                | transloco : { value: vm.populationDensityBoxes | invoke : getRiskLevelGridValue : RiskLevels.High }
                        }}
                    </span>
                </td>
                <td *ngIf="vm.riskTableMax">
                    <div class="tooltip-container">
                        ~{{ vm.riskTableMax | invoke : getBoxShareRatioColorBox : ColorBox.Violet | percent }}
                        <span>
                            {{
                                "dtmUi.riskLevels.gridValue"
                                    | transloco : { value: vm.riskTableMax | invoke : getColorBoxGridValue : ColorBox.Violet }
                            }}
                        </span>
                    </div>
                </td>
            </tr>
            <tr class="row-medium" [class.selected]="vm.densityAfterMitigation === RiskLevels.Medium">
                <td class="risk-title">
                    <div class="tooltip-container">
                        {{ "dtmUi.riskLevels.riskMedium.shortLabel" | transloco }}
                        <div class="tooltip">
                            <dtm-ui-popover>
                                <div class="tooltip-text" [innerHTML]="'dtmUi.riskLevels.riskMedium.tooltipText' | transloco"></div>
                            </dtm-ui-popover>
                        </div>
                    </div>
                </td>
                <td>
                    ~{{ vm.populationDensityBoxes | invoke : getBoxShareRatioRiskLevels : RiskLevels.Medium | percent
                    }}<span>
                        {{
                            "dtmUi.riskLevels.gridValue"
                                | transloco : { value: vm.populationDensityBoxes | invoke : getRiskLevelGridValue : RiskLevels.Medium }
                        }}
                    </span>
                </td>
                <td *ngIf="vm.riskTableMax">
                    <div class="tooltip-container">
                        ~{{ vm.riskTableMax | invoke : getBoxShareRatioColorBox : ColorBox.Red | percent }}
                        <span>
                            {{
                                "dtmUi.riskLevels.gridValue"
                                    | transloco : { value: vm.riskTableMax | invoke : getColorBoxGridValue : ColorBox.Red }
                            }}
                        </span>
                    </div>
                </td>
            </tr>
            <tr class="row-low" [class.selected]="vm.densityAfterMitigation === RiskLevels.Low">
                <td class="risk-title">
                    <div class="tooltip-container">
                        {{ "dtmUi.riskLevels.riskLow.shortLabel" | transloco }}
                        <div class="tooltip">
                            <dtm-ui-popover>
                                <div class="tooltip-text" [innerHTML]="'dtmUi.riskLevels.riskLow.tooltipText' | transloco"></div>
                            </dtm-ui-popover>
                        </div>
                    </div>
                </td>
                <td>
                    ~{{ vm.populationDensityBoxes | invoke : getBoxShareRatioRiskLevels : RiskLevels.Low | percent
                    }}<span>
                        {{
                            "dtmUi.riskLevels.gridValue"
                                | transloco : { value: vm.populationDensityBoxes | invoke : getRiskLevelGridValue : RiskLevels.Low }
                        }}</span
                    >
                </td>
                <td *ngIf="vm.riskTableMax">
                    <div class="tooltip-container">
                        ~{{ vm.riskTableMax | invoke : getBoxShareRatioColorBox : ColorBox.Yellow | percent }}
                        <span>
                            {{
                                "dtmUi.riskLevels.gridValue"
                                    | transloco : { value: vm.riskTableMax | invoke : getColorBoxGridValue : ColorBox.Yellow }
                            }}
                        </span>
                    </div>
                </td>
            </tr>
            <tr class="row-lowest" [class.selected]="vm.densityAfterMitigation === RiskLevels.Lowest">
                <td class="risk-title">
                    <div class="tooltip-container">
                        {{ "dtmUi.riskLevels.riskLowest.shortLabel" | transloco }}
                        <div class="tooltip">
                            <dtm-ui-popover>
                                <div class="tooltip-text" [innerHTML]="'dtmUi.riskLevels.riskLowest.tooltipText' | transloco"></div>
                            </dtm-ui-popover>
                        </div>
                    </div>
                </td>
                <td>
                    ~{{ vm.populationDensityBoxes | invoke : getBoxShareRatioRiskLevels : RiskLevels.Lowest | percent
                    }}<span>
                        {{
                            "dtmUi.riskLevels.gridValue"
                                | transloco : { value: vm.populationDensityBoxes | invoke : getRiskLevelGridValue : RiskLevels.Lowest }
                        }}</span
                    >
                </td>
                <td *ngIf="vm.riskTableMax">
                    <div class="tooltip-container">
                        ~{{ vm.riskTableMax | invoke : getBoxShareRatioColorBox : ColorBox.Green | percent }}
                        <span>
                            {{
                                "dtmUi.riskLevels.gridValue"
                                    | transloco : { value: vm.riskTableMax | invoke : getColorBoxGridValue : ColorBox.Green }
                            }}
                        </span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</ng-container>
